export default ({ request }) => ({
  shipmentExpenseItemListApi(data = {}) {
    return request({
      url: '/financial/shipment/expense/item/list',
      method: 'POST',
      data,
    })
  },
})
